import Reaction from '@linc-technologies/linced-common/models/posts/reaction';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Communitynotice from 'linced-app/models/posts/communitynotice';
import type Staffnotice from 'linced-app/models/posts/staffnotice';
import type Studentnotice from 'linced-app/models/posts/studentnotice';
import type Text from 'linced-app/models/posts/text';

// Proto: posts.Reaction.
export default class _Reaction extends Reaction {
  declare [Type]: 'posts/reaction';

  @belongsTo('posts/communitynotice', { async: true, inverse: 'reactions' })
  declare communityNoticeId: AsyncBelongsTo<Communitynotice>;

  @belongsTo('posts/studentnotice', { async: true, inverse: 'reactions' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;

  @belongsTo('posts/staffnotice', { async: true, inverse: 'reactions' })
  declare staffNoticeId: AsyncBelongsTo<Staffnotice>;

  @belongsTo('posts/text', { async: true, inverse: 'reactions' })
  declare textId: AsyncBelongsTo<Text>;
}
